<div class="container">
  <div class="row">
    <div class="col-md-3">
      <app-info-saas-cadastro
        logo= "logo-imed.PNG"
        titulo= "Experimente agora uma nova rotina médica com uma excelente gestão de agenda e prontuários, com a iMED."
        publicoAlvo= "médicos"
        corFundo= "rgba(29, 161, 242, 0.23)"
        color= "#06adb4"
        imagem="medicaSemfundo.png"
      ></app-info-saas-cadastro>
    </div>
    <div class="col-md-9">
      <app-cadastro-formulario
      tipoSaas = '9f5f628b-6d4b-42d0-b3bb-8c5417e8d64d'
      ></app-cadastro-formulario>
    </div>
  </div>
</div>
